import { http } from "@/http/http.js";



export function roleList(params) {
  return http.post("/web/roleManage/listDefault", params);
}


export function roleDelete(params) {
  return http.post("/web/roleManage/delete", params);
}

export function listDuplicate(params) {
  return http.post("/web/roleManage/listDuplicate", params);
}

export function addRole(params) {
  return http.post("/web/roleManage/add", params);
}

export function updateRole(params) {
  return http.post("/web/roleManage/update", params);
}

export function listRoleMenu(params) {
  return http.post("/web/roleManage/listRoleMenu", params);
}

export function saveRoleMenu(params) {
  return http.post("/web/roleManage/saveRoleMenu",params)
}

export function addEmployeeRole(params) {
  return http.post("/web/roleManage/addEmployeeRole",params)
}

export function listPageEmployeeByRoleId(params) {
  return http.post("/web/roleManage/listPageEmployeeByRoleId",params)
}
export function delEmployeeRole(params) {
  return http.post("/web/roleManage/delEmployeeRole",params)
}

